import { render, staticRenderFns } from "./AuditForm.vue?vue&type=template&id=1038cf1b&scoped=true"
import script from "./AuditForm.vue?vue&type=script&lang=js"
export * from "./AuditForm.vue?vue&type=script&lang=js"
import style0 from "./AuditForm.vue?vue&type=style&index=0&id=1038cf1b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1038cf1b",
  null
  
)

export default component.exports